<template>

    <div>
        <h1 style="text-align: center;line-height: 60px" >Transformer simulation</h1>
        <!--        粉末填料页面一-->
        <el-form ref="form" :model="form" label-width="120px"  style="text-align: left" :rules="rules">

            <el-row >
                <el-col :span="12" >
                    <div class="max">
                        <el-form-item label="Vac" prop="vac">
                            <el-input  type="number"  v-model.trim.number="form.vac" placeholder="Please input the primary voltage(V)"  />
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="12" >
                    <div class="max">

                        <el-form-item label="Np" prop="np">
                            <el-input  type="number"  v-model.trim.number="form.np" placeholder="Number of primary winding turns"  />
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="12" >
                    <div class="max">
                        <el-form-item label="Rp" prop="rp">
                            <el-input  type="number" v-model.trim.number="form.rp"  placeholder="Please enter the primary side resistance(ohm)"  />
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="12" >
                    <div class="max">
                        <el-form-item label="Ns" prop="ns">
                            <el-input  type="number" v-model.trim.number="form.ns"  placeholder="Please enter the winding number of secondary winding"  />
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="12" >
                    <div class="max">
                        <el-form-item label="Rs" prop="rs">
                            <el-input  type="number" v-model.trim.number="form.rs"  placeholder="Please enter the secondary resistance(ohm)"  />
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="12" >
                    <el-form-item label="Frequency" prop="nu">
                        <el-input  type="number" v-model.trim.number="form.nu"  placeholder="Please enter the frequency(Hz)"  />
                    </el-form-item>
                </el-col>
                <el-col :span="12" >
                    <el-form-item label="LoadPower" prop="lowpower" >
                        <el-input  type="number" v-model.trim.number="form.lowpower"  placeholder="Please enter the load power"  />
                    </el-form-item>
                </el-col>
                <el-col :span="12" >
                    <div class="max">
                        <el-form-item label="Rc" prop="rc">
                            <el-input  type="number"  v-model.trim.number="form.rc" placeholder="Please enter the core resistivity(ohm*m)"  />
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="12" >
                    <el-form-item label="Temperature" prop="tAir">
                        <el-input  type="number" v-model.trim.number="form.tAir"  placeholder="Please enter the environment temperature(℃)"  />
                    </el-form-item>
                </el-col>
                <el-col :span="12" >
                    <div class="max">
                        <el-form-item label="muR" prop="muR">
                            <el-input  type="number" v-model.trim.number="form.muR"  placeholder="Please enter the initial permeability"  />
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="12" >
                    <el-form-item label="WireDiameter1" prop="wd">
                        <el-input  type="number"  v-model.trim.number="form.wd" placeholder="Please enter the wire diameter1(mm)"  />
                    </el-form-item>
                </el-col>
                <el-col :span="12" >
                    <el-form-item label="WireDiameter2" prop="wd2">
                        <el-input  type="number" v-model.trim.number="form.wd2"  placeholder="Please enter the wire diameter2(mm)"  />
                    </el-form-item>
                </el-col>
            </el-row>
            <!--              摩擦系数结束-->
            <!--              粉末间摩擦系数结束-->

            <el-form-item label="Cooling">
                <el-select v-model="form.model" placeholder="Please select cooling method">
                    <el-option label="Natural cooling" :value="0"></el-option>
                    <el-option label="Air cooling" :value="1"></el-option>
                    <el-option label="Water cooling" :value="2"></el-option>
                </el-select>
            </el-form-item>

            <el-row v-if="feng">
                <el-col :span="12" >
                    <div class="max">
                        <el-form-item label="hCoil" prop="hCoil">
                            <el-input  type="number" v-model.trim.number="form.hCoil" placeholder="Please enter the forced convection heat exchange coefficient(W/m^2/k)"  />
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="12" >
                    <div class="max">
                        <el-form-item label="kc" prop="kc">
                            <el-input  type="number" v-model.trim.number="form.kc"  placeholder="Please enter the core thermal conductivity" model-value="1.6" disabled />
                        </el-form-item>
                    </div>
                </el-col>


            </el-row>

            <el-row v-if="shui">
                <el-col :span="12" >
                    <div class="max">
                        <el-form-item label="WaterTemperature" prop="tWater">
                            <el-input  type="number" v-model.trim.number="form.tWater"  placeholder="Please enter the cooling water temperature(℃)"  />
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="12" >
                    <div class="max">
                        <el-form-item label="hCore" prop="hCore">
                            <el-input  type="number" v-model.trim.number="form.hCore" placeholder="Please enter the core heat transfer coefficient(W/m^2/k)" />
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="12" >
                    <div class="max">
                        <el-form-item label="hCoil" prop="hCoil">
                            <el-input  type="number" v-model.trim.number="form.hCoil" placeholder="Please input the coil cooling heat transfer coefficient(W/m^2/k)"  />
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="12" >
                    <div class="max">
                        <el-form-item label="kc" prop="kc">
                            <el-input  type="number" v-model.trim.number="form.kc" placeholder="Please enter the core thermal conductivity" model-value="1.6" disabled />
                        </el-form-item>
                    </div>
                </el-col>

            </el-row>

            <el-form-item label="Calculation">
                <el-select v-model="form.emulationMode"  placeholder="Please select the calculation method">
                    <el-option label="The steady state calculation" :value="0"></el-option>
                    <el-option label="Transient calculation: sine wave" :value="1"></el-option>
                    <el-option label="Transient calculation: pulse wave" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-row v-if="jisuan">
                <el-col :span="12" >
                    <div class="max">
                        <el-form-item label="Time delay" prop="delay">
                            <el-input  type="number" v-model="form.delay" placeholder="Please enter the delay time(s)" model-value="30" />
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="12" >
                    <el-form-item label="RiseTime" prop="risetime">
                        <el-input  type="number" v-model="form.risetime" placeholder="Please enter rise time(s)"  />
                    </el-form-item>
                </el-col>
                <el-col :span="12" >
                    <el-form-item label="FallTime" prop="falltime">
                        <el-input  type="number" v-model="form.falltime" placeholder="Please enter fall time(s)"  />
                    </el-form-item>
                </el-col>
                <el-col :span="12" >
                    <el-form-item label="PulseWidth" prop="pulsewidth">
                        <el-input  type="number" v-model="form.pulsewidth"  placeholder="Please enter pulse width(mm)" model-value="1.6"  />
                    </el-form-item>
                </el-col>
                <el-col :span="24" >
                    <img src="../../assets/tip.png" alt="" style="width: 657px">
                </el-col>
            </el-row>

<!--            <el-row>-->
<!--                <el-col :span="24" >-->
<!--                    <div class="block" style="line-height: 42px;margin-bottom: 10px">-->
<!--                        <el-row>-->

<!--                            <el-col :span="3" style="text-align: left;">-->

<!--                                <div class="max">-->
<!--                                    <el-form-item label="grid Level">-->
<!--                                    </el-form-item>-->
<!--                                </div>-->
<!--                            </el-col>-->
<!--                            <el-col :span="3" ><span class="demonstration">accurate(5)</span></el-col>-->
<!--                            <el-col :span="8" ><el-slider v-model="form.gridLevel" :min="5" :max="9" step="1"></el-slider></el-col>-->
<!--                            <el-col :span="3" style="text-align: right;"><span class="demonstration">rough(9)</span></el-col>-->
<!--                        </el-row>-->

<!--                    </div>-->
<!--                </el-col>-->
<!--            </el-row>-->

            <div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="Product" prop="x">
                            <el-input  v-model.trim="form.x" placeholder="The name of Product" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Materials" prop="y">
                            <el-input  v-model.trim="form.y" placeholder="The name of Materials" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="Company" prop="z">
                            <el-input  v-model.trim="form.z" placeholder="The name of Company" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="User" prop="aa">
                            <el-input  v-model.trim="form.aa" placeholder="The name of User" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">

                        <el-form-item

                                label="Email"
                                prop="bb"
                                :rules="[{ required: true, message: 'Please enter your email address', trigger: 'blur' },{ type: 'email', message: 'Please enter the correct email address', trigger: ['blur', 'change'] }]"
                        >
                            <el-input  v-model.trim="form.bb" placeholder="Please enter your email address" />
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit" :loading=loading>Submit</el-button>

                </el-form-item>

            </div>



        </el-form>

    </div>

</template>

<script>
    import request from "@/utils/request";

    export default {
        name: 'IfcoresTransformer',
        props:["formToIfcoresTransformer"],
        data () {
            var check=(rule, value, callback) =>{
                if (value) {
                    let tip = "";
                    if (value* 1<0){
                        tip = "The value must be greater than 0"
                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                } else {

                }

            }

            return {
                feng:false,
                shui:false,
                //冷却方式
                jisuan:false,
                loading:false,
                form:{
                    model:0,
                    emulationMode:0,
                    gridLevel:5,
                    kc:1.6,
                    hCore:5.5,
                    hCoil:5.5,
                    tWater:20,
                    delay: 30,
                    pulsewidth: 1.6





                },
                rules:{
                    vac:[
                        {required: true, message: 'Primary side voltage is required data', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    np:[
                        {required: true, message: 'Primary winding number is a required data', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    rp:[
                        {required: true, message: 'The primary resistance is a required data', trigger: 'blur'},
                        // {validator: check, trigger: 'blur'}
                    ],
                    ns:[
                        {required: true, message: 'The secondary winding number is required', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    rs:[
                        {required: true, message: 'The secondary resistance is a required data', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    nu:[
                        {required: true, message: 'Frequency is required data', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    lowpower:[
                        {required: true, message: 'Load power is required data', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    rc:[
                        {required: true, message: 'Core resistivity is a required data', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    tAir:[
                        {required: true, message: 'Ambient temperature is a required data', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    muR:[
                        {required: true, message: 'Initial permeability is a required data', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    wd:[
                        {required: true, message: 'Line diameter 1 is a required data', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    wd2:[
                        {required: true, message: 'Line diameter 2 is required', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    hCoil:[
                        {required: true, message: 'The forced convective heat exchange coefficient is a necessary data', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    kc:[
                        {required: true, message: 'Core thermal conductivity is a required data', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    tWater:[
                        {required: true, message: 'Cooling water temperature is a required data', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    hCore:[
                        {required: true, message: 'Core heat transfer coefficient is a required data', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    risetime:[
                        {required: true, message: 'The rise time is the required data', trigger: 'blur'},
                        // {validator: check, trigger: 'blur'}
                    ],
                    falltime:[
                        {required: true, message: 'Time of descent is required data', trigger: 'blur'},
                        // {validator: check, trigger: 'blur'}
                    ],
                    pulsewidth:[
                        {required: true, message: 'Pulse width is a required data', trigger: 'blur'},
                        // {validator: check, trigger: 'blur'}
                    ],
                    delay:[
                        {required: true, message: 'Delay is required data', trigger: 'blur'},
                        // {validator: check, trigger: 'blur'}
                    ],
                    x:[
                        { required: true, message: 'Product is required data', trigger: 'blur' },
                    ],
                    y:[
                        { required: true, message: 'Materials is required data', trigger: 'blur' },

                    ],
                    z:[
                        { required: true, message: 'Company is required data', trigger: 'blur' },

                    ],
                    aa:[
                        { required: true, message: 'User is required data', trigger: 'blur' },

                    ],
                    bb:[
                        { required: true, message: 'Please enter your email address', trigger: 'blur' },
                        { type: 'email', message: 'Please enter the correct email address', trigger: ['blur', 'change'] }
                    ]
                }                //


            }
        },
        mounted() {

        },
        created() {
            this.form={...this.formToIfcoresTransformer,...this.form}
        },
        methods: {
            setMsg(val){
                this.form.x=val
            },
            onSubmit(){
                let forms={...this.formToIfcoresTransformer,...this.form}
                this.$refs['form'].validate((valid) => {
                    if (valid){
                        this.loading=true
                        request.post("http://www.magdraw.com/api/list/EN/addDrawlist3",forms).then(res =>{


                            if (res.code=='0'){
                                this.loading=false
                                this.$message({
                                    type:"success",
                                    message:"succeed"
                                })

                            }else{
                                this.loading=false
                                this.$message({
                                    type:"error",
                                    message:res.msg
                                })
                            }

                        })

                    }else{
                        // alert("有报错")
                    }
                })

            }
        },
        watch:{
            form:{//深度监听，可监听到对象、数组的变化
                handler(val){
                    if(val.emulationMode==2){
                        this.jisuan=true

                    }else if(val.emulationMode==1){
                        val.tWater=val.tAir

                        this.jisuan=false

                    }else{

                        val.tWater=20
                        val.hCore=5.5;
                        val.hCoil=5.5;
                        this.jisuan=false

                    }
                    if(val.model==1){
                        this.feng=true
                        this.shui=false
                    }else if(val.model==2){
                        this.feng=false
                        this.shui=true
                    }else{
                        this.feng=false
                        this.shui=false
                    }

                },
                deep:true //true 深度监听
            },



        }


    }
</script>


<style scoped>

    i:hover{
        cursor: pointer;
        color: #db261d;
    }
    .border{

        margin-top: 60px;
        height: calc(100vh - 120px);
    }

    .el-input{
        width: 90%;
    }
    div::-webkit-scrollbar {
        display: none;
    }
    /deep/
    input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
    }

    .max >>>.el-form-item__label{
        line-height: 20px !important;
    }
    img:hover{
        cursor: pointer;
    }
    img{
        height: 200px;width: 200px;border: 1px solid #ccc
    }
    .active{
        border: 1px solid orange !important;
    }
</style>

